export function prepararVistaPreviaTicket(ventana, { alFinalizar } = {}) {
  const doc = ventana.document;
  const hoja = doc.createElement('main');
  hoja.id = 'ticket-vista-previa';
  while (doc.body.firstChild) hoja.appendChild(doc.body.firstChild);
  doc.body.appendChild(hoja);

  const estilo = doc.createElement('style');
  estilo.textContent = `
    @media screen {
      html { width: auto !important; background: #e2e8f0 !important; }
      body { width: auto !important; margin: 0 !important; padding: 20px !important; background: #e2e8f0 !important; }
      #ticket-vista-previa { width: 58mm; padding: 10px; margin: 20px auto; background: white; color: black; box-shadow: 0 4px 20px #0002; zoom: 2; }
      #ticket-controles { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 12px; font: 16px Arial,sans-serif; padding: 14px; background: white; border-radius: 8px; }
      #ticket-controles button { padding: 10px 16px; font: inherit; border: 0; border-radius: 6px; cursor: pointer; background: #0f172a; color: white; }
      #ticket-controles label { display: flex; align-items: center; gap: 8px; }
    }
    @media print {
      #ticket-controles { display: none !important; }
      #ticket-vista-previa { zoom: 1 !important; width: auto !important; margin: 0 !important; padding: 0 !important; box-shadow: none !important; }
    }`;
  doc.head.appendChild(estilo);
  const controles = doc.createElement('nav');
  controles.id = 'ticket-controles';
  controles.setAttribute('aria-label', 'Vista previa del ticket');
  controles.innerHTML = '<button type="button" id="ticket-imprimir">Imprimir</button><label>Tamaño en pantalla <input id="ticket-ampliacion" type="range" min="100" max="300" step="25" value="200"><output id="ticket-porcentaje">200%</output></label><button type="button" id="ticket-cerrar">Cerrar</button>';
  doc.body.insertBefore(controles, hoja);
  let finalizado = false;
  const finalizar = () => {
    if (!finalizado) { finalizado = true; alFinalizar?.(); }
  };
  doc.getElementById('ticket-ampliacion').addEventListener('input', (event) => {
    const valor = Math.min(300, Math.max(100, Number(event.target.value) || 200));
    hoja.style.zoom = valor / 100;
    doc.getElementById('ticket-porcentaje').textContent = `${valor}%`;
  });
  doc.getElementById('ticket-imprimir').addEventListener('click', () => { ventana.focus(); ventana.print(); });
  doc.getElementById('ticket-cerrar').addEventListener('click', () => { finalizar(); ventana.close(); });
  ventana.addEventListener('afterprint', finalizar);
  ventana.addEventListener('beforeunload', finalizar);
  ventana.focus();
}
